import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-file',
  template: `
    <div class="composed-menu-input">
      <mat-form-field floatLabel="never">
        <button matPrefix mat-flat-button (click)="fileInput.click()">
          {{ 'login.attach' | translate }}
          <span class="odilo-icon">link</span>
        </button>
        <input
          matInput
          readonly
          name="id"
          type="text"
          [value]="fileInput.value"
          placeholder="{{ 'user.fields.attachFile' | translate }}" />
      </mat-form-field>
    </div>
    <input hidden #fileInput type="file" [formControl]="formControl" [formlyAttributes]="field" />
  `,
})
export class FormlyFieldFileComponent extends FieldType<FieldTypeConfig> {}
